export default "__VITE_ASSET__CiLkseaF__"